import React from 'react';

export const ConsultarContexto = React.createContext(null);